<style scoped>
.ivu-modal-wrap {
  background: rgba(0, 0, 0, 0.9);
}
</style>

<template>
  <div>
    <!-- <Content :style="{background: '#fff',padding:'15px'}"> -->
    <Card shadow>
      <div>
        <Input
          style="width:200px;float:left;margin-right:10px"
          search
          enter-button
          placeholder="项目检索"
          @on-search="searchCreatedProjects"
          v-model="projectsdata.keyword"
        />
        <Button @click="showProjectAddModal" icon="md-add" type="primary">添加项目</Button>
      </div>
      <Table
        stripe
        :columns="projectsdata.col_data"
        :data="projectsdata.current_data"
        :loading="projectsdata.loading"
        class="tc"
        style="margin-top:10px"
        @on-row-click="selectProjectItem"
      ></Table>
      <div style="margin-top: 10px;overflow: hidden">
        <div style="text-align:center">
          <Page
            :current.sync="projectsdata.current_index"
            @on-change="on_page_change"
            :page-size="projectsdata.page_size"
            :total="projectsdata.total"
          ></Page>
        </div>
      </div>
    </Card>

    <Modal
      :scrollable="true"
      v-model="addprojectmodal"
      title="添加项目"
      width="800"
      :footer-hide="true"
      @on-visible-change="addProjectModalVisible"
    >
      <Input
        search
        enter-button
        placeholder="项目名称，可模糊检索"
        @on-search="projectSearch"
        v-model="prjSearchKeyWord"
      />
      <Table
        style="margin-top:10px"
        size="small"
        :columns="tdata.col_data"
        :data="tdata.current_data"
        :loading="tdata.loading"
        @on-row-click="projectFindRowSelect"
      ></Table>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      addprojectmodal: false,
      prjSearchKeyWord: "",
      projectsdata: {
        keyword: "",
        //数据总量
        total: 0,
        //每页数量
        page_size: 15,
        //当前分页索引
        current_index: 1,
        //是否显示loading框
        loading: true,
        //当前表格数据
        current_data: [],
        //表头数据
        col_data: [
          {
            type: "index2",
            width: 80,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                params.index +
                  (this.projectsdata.current_index - 1) *
                    this.projectsdata.page_size +
                  1
              );
            },
          },
          {
            title: "项目名称",
            key: "projectname",
          },
          {
            title: "所属BU",
            key: "buname",
          },
          {
            title: "所属BG",
            key: "bgname",
          },
          {
            title: "项目经理",
            key: "pmname",
            width: 200,
          },
          {
            title: "添加人员",
            key: "displayname",
            width: 200,
          },
          {
            title: "添加时间",
            key: "createTime",
            width: 200,
          },
        ],
      },
      tdata: {
        //是否显示loading框
        loading: false,
        //当前表格数据
        current_data: [],
        //表头数据
        col_data: [
          {
            type: "index",
            width: 60,
            align: "center",
          },
          {
            title: "项目名称",
            key: "XiangMuMC",
          },
          {
            width: 300,
            title: "项目经理",
            key: "PMMange",
          },
        ],
      },
    };
  },
  methods: {
    //检索已经注册的项目
    searchCreatedProjects() {
      this.projectsdata.current_index = 1;
      this.on_page_change(this.projectsdata.current_index);
    },
    //分页加载项目列表数据
    on_page_change(index) {
      let _this = this;
      this.$http.get({
        method: "mqms/project/getlist/v2",
        params: {
          keyword: _this.projectsdata.keyword,
          index: index,
          size: _this.projectsdata.page_size,
        },
        success: function (data) {
          _this.projectsdata.loading = false;
          _this.projectsdata.current_data = data.data;
          _this.projectsdata.total = data.totalCount;
        },
        failure(code, msg) {},
      });
    },
    //选中项目的事件
    selectProjectItem(row) {
      // window.open("#/projectoverview/" + row.projectguid);

      this.$router.push({
        name: "projectoverview",
        params: { projectguid: row.projectguid },
      });
    },
    //添加项目对话框显隐回调
    addProjectModalVisible() {
      this.tdata.current_data = [];
      this.prjSearchKeyWord = "";
    },
    //显示添加项目对话框
    showProjectAddModal() {
      this.addprojectmodal = true;
    },
    //在项目管理系统接口中检索项目用于添加
    projectSearch() {
      let _this = this;
      this.tdata.current_data = [];
      this.tdata.loading = true;
      this.$http.get({
        method: "pmsys/findlist",
        params: {
          keyword: this.prjSearchKeyWord,
        },
        success: function (data) {
          _this.tdata.current_data = data;
          _this.tdata.loading = false;
        },
        failure(code, msg) {},
      });
    },
    //选中一个项目添加到本地库
    projectFindRowSelect(row) {
      let _this = this;
      this.$http.get({
        method: "pmsys/getdetail",
        params: {
          rowguid: row.RowGuid,
        },
        success: function (data) {
          _this.addprojectmodal = false;
          _this.addProject(row);
        },
        failure(code, msg) {},
      });
    },
    //将选中的项目添加到本地库
    addProject(row) {
      let _this = this;
      this.$http.post({
        method: "mqms/project/add",
        params: {
          projectguid: row.RowGuid,
          projectname: row.XiangMuMC,
          pmname: row.PMMange,
        },
        success: function (data) {
          _this.projectsdata.keyword = "";
          _this.projectsdata.current_index = 1;
          _this.on_page_change(_this.projectsdata.current_index);
        },
        failure(code, msg) {
          _this.$Modal.warning({
            title: "提示",
            content: msg,
          });
        },
      });
    },
  },
  mounted() {
    this.on_page_change(this.projectsdata.current_index);
  },
};
</script>